<template>
	<div class="padding-lg">
		<el-row :gutter="20">
			<el-col :span="16">
				<div class="text-xl text-black padding-lg bg-white radius solid">{{ $route.meta.title }}</div>
				<div class="padding-lg bg-white radius solid margin-top">
					<div class="text-lg text-black padding-top-sm flex justify-between align-center">
						<div class="name"><span>客户信息</span></div>
						<div class="action"><el-button>修改</el-button></div>
					</div>
					<el-divider></el-divider>
					<div class="padding-top-xl">
						<div class="infoshow">
							<div class="title">名称：</div>
							<div class="con">
								<span>{{ info.customer.name }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">统一社会信用代码：</div>
							<div class="con">
								<span class="text-lg text-grey">{{ info.customer.credit_code }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">类型：</div>
							<div class="con">
								<span class="text-lg text-blue text-bold">{{ info.customer.type }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">地址：</div>
							<div class="con">
								<div class="text-bold">
									<span>{{ info.customer.province }}</span>
									<span>{{ info.customer.city }}</span>
									<span>{{ info.customer.district }}</span>
								</div>
								<div>{{ info.customer.address }}</div>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">销售：</div>
							<div class="con">
								<span class="" v-if="info.customer.salesman">{{ info.customer.salesman.name }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">客服：</div>
							<div class="con">
								<span class="" v-if="info.customer.service">{{ info.customer.service.name }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">创建时间：</div>
							<div class="con">
								<span class="">{{ info.addtime }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="padding-lg bg-white radius solid margin-top">
					<div class="text-lg text-black padding-top-sm flex justify-between align-center">
						<div class="name"><span>业务内容</span></div>
						<div class="action"><el-button>修改</el-button></div>
					</div>
					<el-divider></el-divider>
					<div class="padding-top-xl">
						<div class="infoshow">
							<div class="title">服务状态：</div>
							<div class="con">
								<span v-if="state_arr" :class="'cu-tag radius bg-' + state_arr[info.state].color">{{ state_arr[info.state].name }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">业务联系人：</div>
							<div class="con">
								<el-popover placement="right" trigger="click" v-if="info.contacter">
									<div class="flex justify-between solid-bottom align-center">
										<div>
											<span class="el-icon-user"></span>
											<span class="margin-left-xs">联系人信息</span>
										</div>
										<div><el-button type="text" size="mini">修改</el-button></div>
									</div>
									<div class="infoshow-list">
										<div class="item">
											<div class="title">姓名：</div>
											<div class="content">{{ info.contacter.name }}</div>
										</div>
										<div class="item">
											<div class="title">性别：</div>
											<div class="content">{{ info.contacter.gender }}</div>
										</div>
										<div class="item">
											<div class="title">身份：</div>
											<div class="content">{{ info.contacter.status }}</div>
										</div>
										<div class="item" v-if="info.contacter.position">
											<div class="title">职务：</div>
											<div class="content">{{ info.contacter.position }}</div>
										</div>
										<div class="item" v-if="info.contacter.mobile">
											<div class="title">手机：</div>
											<div class="content">{{ info.contacter.mobile }}</div>
										</div>
										<div class="item" v-if="info.contacter.qq">
											<div class="title">QQ：</div>
											<div class="content">{{ info.contacter.qq }}</div>
										</div>
										<div class="item" v-if="info.contacter.weixin">
											<div class="title">微信：</div>
											<div class="content">{{ info.contacter.weixin }}</div>
										</div>
										<div class="item" v-if="info.contacter.email">
											<div class="title">邮箱：</div>
											<div class="content">{{ info.contacter.email }}</div>
										</div>
									</div>
									<span slot="reference" class="text-link">{{ info.contacter.name }}</span>
								</el-popover>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">税务类型：</div>
							<div class="con"><span class="cu-tag bg-blue radius" v-if="info.taxtype == 1">小规模纳税人</span></div>
						</div>
						<div class="infoshow">
							<div class="title">服务期限：</div>
							<div class="con">
								<span class="text-lg">{{ info.begintime }}</span>
								至
								<span class="text-lg">{{ info.endtime }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">服务内容：</div>
							<div class="con">
								<span class="">{{ info.service_content }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">服务级别：</div>
							<div class="con">
								<span class="">{{ info.service_level }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">账务工作量：</div>
							<div class="con">
								<span class="">{{ info.workload }}</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">财税顾问：</div>
							<div class="con">
								<span class="" v-if="info.post.gw" v-for="item in info.post.gw">
									<el-popover placement="right" trigger="click" v-if="item">
										<div class="flex justify-between solid-bottom align-center">
											<div class="padding-bottom-sm">
												<span class="el-icon-user"></span>
												<span class="margin-left-xs">个人信息</span>
											</div>
										</div>
										<div class="infoshow-list">
											<div class="item">
												<div class="title">姓名：</div>
												<div class="content">{{ item.user.name }}</div>
											</div>
											<div class="item">
												<div class="title">工号：</div>
												<div class="content">{{ item.user.officeid }}</div>
											</div>
											<div class="item">
												<div class="title">部门：</div>
												<div class="content">{{ item.user.department }}</div>
											</div>
											<div class="item" v-if="item.user.position">
												<div class="title">职务：</div>
												<div class="content">{{ item.user.position }}</div>
											</div>
											<div class="item">
												<div class="title">开始时间：</div>
												<div class="content">{{ item.begintime }}</div>
											</div>
											<div class="item">
												<div class="title">结束时间：</div>
												<div class="content">{{ item.endtime }}</div>
											</div>
											<div class="item">
												<div class="title">累计时长：</div>
												<div class="content">{{ item.days }}天</div>
											</div>
										</div>
										<span slot="reference" class="text-link">{{ item.user.name }}</span>
									</el-popover>
								</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">账务会计：</div>
							<div class="con">
								<span class="" v-if="info.post.gw" v-for="item in info.post.zw">
									<el-popover placement="right" trigger="click" v-if="item">
										<div class="flex justify-between solid-bottom align-center">
											<div class="padding-bottom-sm">
												<span class="el-icon-user"></span>
												<span class="margin-left-xs">个人信息</span>
											</div>
										</div>
										<div class="infoshow-list">
											<div class="item">
												<div class="title">姓名：</div>
												<div class="content">{{ item.user.name }}</div>
											</div>
											<div class="item">
												<div class="title">工号：</div>
												<div class="content">{{ item.user.officeid }}</div>
											</div>
											<div class="item">
												<div class="title">部门：</div>
												<div class="content">{{ item.user.department }}</div>
											</div>
											<div class="item" v-if="item.user.position">
												<div class="title">职务：</div>
												<div class="content">{{ item.user.position }}</div>
											</div>
											<div class="item">
												<div class="title">开始时间：</div>
												<div class="content">{{ item.begintime }}</div>
											</div>
											<div class="item">
												<div class="title">结束时间：</div>
												<div class="content">{{ item.endtime }}</div>
											</div>
											<div class="item">
												<div class="title">累计时长：</div>
												<div class="content">{{ item.days }}天</div>
											</div>
										</div>
										<span slot="reference" class="text-link">{{ item.user.name }}</span>
									</el-popover>
								</span>
							</div>
						</div>
						<div class="infoshow">
							<div class="title">创建时间：</div>
							<div class="con">
								<span class="">{{ info.addtime }}</span>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="8"></el-col>
		</el-row>

		<el-dialog title="处理订单" :visible.sync="dialogVisibleDeal" width="600px">
			<el-form ref="formDeal" :model="formDeal" label-width="130px" label-suffix=":">
				<el-form-item required="" label="处理结果">
					<el-radio-group v-model="formDeal.state"><el-radio label="通过" :value="6"></el-radio></el-radio-group>
				</el-form-item>
				<el-form-item required="" prop="reply" label="处理回执">
					<el-input v-model="formDeal.reply" type="textarea" placeholder="请输入处理回执" :rows="5" maxlength="140" show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: '',
			state_arr: null,
			info: {
				customer: {
					name: ''
				}
			},
			formDeal: {},
			dialogVisibleDeal: false
		};
	},
	beforecreate: function() {},
	created: function() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
		} else {
			this.$alert('页面参数错误！', {
				title: '操作错误',
				type: 'error',
				callback: r => {
					this.$router.back(-1);
				}
			});
			return false;
		}
		const loading = this.$loading({
			lock: true,
			text: '加载中...',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		this.$http.post('/server/index.php?m=dljz/fw/view&a=init', { id: this.id }).then(
			res => {
				loading.close();
				if (typeof res.data != 'object') {
					this.$alert(res.data ? res.data : '(无返回数据)', {
						title: '返回数据格式错误',
						type: 'error'
					});
				} else {
					if (res.data.result == 'ok') {
						this.state_arr = res.data.data.state_arr;
						this.info = res.data.data.info;
					} else {
						this.$alert(res.data.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				}
			},
			r => {
				loading.close();
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		image_preview(url) {
			console.log('preview');
			this.dialogImageUrl = url;
			this.dialogVisible = true;
		},
		deal: function(type) {
			if (type == 'start') {
				this.$confirm('你确定要开始处理该订单吗？<br />确认后其他人将无法处理！', {
					title: '操作确认',
					type: 'warning',
					dangerouslyUseHTMLString: true,
					callback: r => {
						console.log(r);
						if (r == 'confirm') {
							const loading = this.$loading({
								lock: true,
								text: '加载中...',
								background: 'rgba(0, 0, 0, 0.7)'
							});
							this.$http.post('/server/api/order/view.php?a=deal_start', { id: this.orderid }).then(
								res => {
									loading.close();
									if (typeof res.data != 'object') {
										this.$alert(res.data ? res.data : '(无返回数据)', {
											title: '返回数据格式错误',
											type: 'error'
										});
									} else {
										if (res.data.result == 'ok') {
											this.deal('deal');
										} else {
											this.$alert(res.data.msg, {
												title: '操作错误',
												type: 'error'
											});
										}
									}
								},
								r => {
									loading.close();
									this.$alert('网络错误，指定的服务无法访问。', {
										title: '系统错误',
										type: 'error'
									});
								}
							);
						}
					}
				});
			} else if (type == 'deal') {
				this.dialogVisibleDeal = true;
			}
		}
	}
};
</script>

<style>
.avatar-uploader {
	cursor: pointer;
}
.hide .el-upload--picture-card {
	display: none;
}

.product-item {
	cursor: pointer;
	border: #929181 2px dashed;
}
.product-item:hover {
	border-color: #409eff;
}
.product-item.active {
	border: #409eff 2px solid;
}

.infoshow .title {
	min-width: 150px;
}
</style>
